export const enumToValueOptions = (enumValues) => {
  return Object.keys(enumValues).map((key) => ({
    label: key.toUpperCase(),
    value: key,
  }));
};
